var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97959 16.7035C8.86182 16.7048 8.74506 16.6835 8.6368 16.6411C8.52855 16.5987 8.4312 16.536 8.35102 16.457L0.269388 9.06419C-0.0897959 8.73562 -0.0897959 8.22633 0.269388 7.89776L8.35102 0.521331C8.71021 0.192759 9.26694 0.192759 9.62612 0.521331C9.98531 0.849902 9.98531 1.35919 9.62612 1.68776L2.17306 8.48919L9.62612 15.307C9.98531 15.6356 9.98531 16.1449 9.62612 16.4735C9.44653 16.6378 9.21306 16.7199 8.99755 16.7199L8.97959 16.7035Z",
    fill: "#688AC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f6d520f72d412a8caa04b9e2492ac3ee.svg";
export { ForwardRef as ReactComponent };